module.exports = __webpack_public_path__ + "media/images/favicons/tastee-society/favicon-32x32-7a6ca9f8f398891ed202b23ddef4bb83.png";